import { type ColorTokenMode, getColorTokens } from './tokens';
import type { AlertColor } from '@mui/material';

const buildUiTokens = (
  mode: ColorTokenMode,
): {
  statusColors: {
    neutral: string;
    green: string;
    red: string;
    orange: string;
    brown: string;
    teal: string;
    purple: string;
    pink: string;
    blue: string;
  };
} => {
  const colorTokens = getColorTokens(mode);
  return {
    statusColors: {
      neutral: colorTokens.neutral,
      green: colorTokens.green,
      red: colorTokens.red,
      orange: colorTokens.orange,
      brown: colorTokens.brown,
      teal: colorTokens.teal,
      purple: colorTokens.purple,
      pink: colorTokens.pink,
      blue: colorTokens.blue,
    },
  } as const;
};

export type UiTokens = ReturnType<typeof buildUiTokens>;

export const getUiTokens = (mode: ColorTokenMode): UiTokens => buildUiTokens(mode);

export const uiTokens = buildUiTokens('light');

export const lightModeStatusColors = {
  green: '#63a45f',
  red: '#c96d68',
  orange: '#d29a4d',
  brown: '#967a70',
  purple: '#9a78d4',
  blue: '#629dc4',
  teal: '#0a9292',
  pink: '#d26387',
  neutral: '#b3bac5',
} as const satisfies UiTokens['statusColors'];

export const lightModeChartStatusColors = {
  green: '#78b872',
  red: '#d9827d',
  orange: '#d9a85b',
  brown: '#aa8f86',
  purple: '#aa8add',
  blue: '#78add0',
  teal: '#3f8e8a',
  pink: '#dc7ea0',
  neutral: '#c3c9d2',
} as const satisfies UiTokens['statusColors'];

export type UiTone = keyof typeof uiTokens.statusColors;

export const chartStatusDarkenCoefficient = 0.18;

export const uiToneSeverityMap: Record<UiTone, AlertColor> = {
  neutral: 'info',
  green: 'success',
  red: 'error',
  orange: 'warning',
  brown: 'warning',
  blue: 'info',
  purple: 'info',
  pink: 'info',
  teal: 'info',
};
